import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiButton, EuiSpacer } from '@elastic/eui';
import { Link } from 'gatsby';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Cloud/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemAlarmPerm';
import CloudTable from 'components/Web_User_Interface/1440p_Series/Cloud/CloudTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "INSTAR Cloud – Sichere Speicherung & Smart Skill",
  "path": "/Web_User_Interface/1440p_Serie/Cloud/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Aufnahmen sicher auf deutschen Cloud Servern aufbewahren und Smarthome-Skills wie z.B. Alexa und IFTTT wahrnehmen.",
  "image": "./WebUI_1440p_SearchThumb_Cloud.webp",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Cloud.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const FTPTable = makeShortcode("FTPTable");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='INSTAR Cloud – Sichere Speicherung & Smart Skill' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Aufnahmen sicher auf deutschen Cloud Servern aufbewahren und Smarthome-Skills wie z.B. Alexa und IFTTT wahrnehmen.' image='/images/Search/WebUI_1440p_SearchThumb_Cloud.webp' twitter='/images/Search/WebUI_1440p_SearchThumb_Cloud.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Cloud/' locationFR='/fr/Web_User_Interface/1440p_Series/Cloud/' crumbLabel="INSTAR Cloud" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "instar-cloud",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#instar-cloud",
        "aria-label": "instar cloud permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`INSTAR Cloud`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/9d95f1e0a45423db58ab2dfd3590571c/024d6/1440p_Settings_Cloud.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50.43478260869565%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACO0lEQVQoz1WRWWsTYRSG8zPEFnqhSSeZSduMdEkmyWSZJE0zS+abrWmprVSKtbZWvXBJiwjiciF44RLQIijEDRSE+vceSWptvHh4+eDw8L3nxNLpNIqSJiklULUarVvvqe+9w7jRo7rTQ99+S/HaG/QRBu/6bg/7zhGt8Arj588xNjbGxMQEMVmWkWUFKRFnttBg9eFnooM+y4d9Ood9gu4Z/kgO5tYffaHeXkOWkijKFKmUQiyVSjEgmUySmZnGs5tEwhoSuiau2aBt1ocprBParRrLfptO6FPWyxQLBuVSjVy2ePpDeShUVZUgjOisrBItd4b4QYgQHrbTpmVaJ7RamG5Iu7PJYr1BSa9QLFRYmNfOhJIkkclkCIOAlU6HKAwQQuC67jCrhkFO08jlNHLZLPNzsxjVCr5YxKiUKBaqLMzn/xeqagbTESxaHi3HJ4qifwjXxbEtHMemKXwaIsDyfDphDaOioxcq5LL50coS0zMqe+s2z3YsulctPE8M63rCxbu8jdjqIjb2uWk63GvZbNkObdugquvUKmW0XG5EKEko0xm6m0t8utvk5W5zKHKFwLZM2hu3WXvQY3X/OU/cgNeOx4Hw2fBNjFJxKMwuaMQGxzi9dCqV5KKkMH5BZuqSRqU8qGNgNpd4fH+PD6+e8vPXD46Pv/H14xG/v/d5cX2NZrWIXvwrHOxu9NKD6qnkJNJkgkRikng8wcyUQjmfJa9p6CUdQ89TLeQxqmXm1DSylCAeH8zG+QPfg3cmJoIa4gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9d95f1e0a45423db58ab2dfd3590571c/e4706/1440p_Settings_Cloud.avif 230w", "/de/static/9d95f1e0a45423db58ab2dfd3590571c/d1af7/1440p_Settings_Cloud.avif 460w", "/de/static/9d95f1e0a45423db58ab2dfd3590571c/7f308/1440p_Settings_Cloud.avif 920w", "/de/static/9d95f1e0a45423db58ab2dfd3590571c/7733b/1440p_Settings_Cloud.avif 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/9d95f1e0a45423db58ab2dfd3590571c/a0b58/1440p_Settings_Cloud.webp 230w", "/de/static/9d95f1e0a45423db58ab2dfd3590571c/bc10c/1440p_Settings_Cloud.webp 460w", "/de/static/9d95f1e0a45423db58ab2dfd3590571c/966d8/1440p_Settings_Cloud.webp 920w", "/de/static/9d95f1e0a45423db58ab2dfd3590571c/85db8/1440p_Settings_Cloud.webp 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9d95f1e0a45423db58ab2dfd3590571c/81c8e/1440p_Settings_Cloud.png 230w", "/de/static/9d95f1e0a45423db58ab2dfd3590571c/08a84/1440p_Settings_Cloud.png 460w", "/de/static/9d95f1e0a45423db58ab2dfd3590571c/c0255/1440p_Settings_Cloud.png 920w", "/de/static/9d95f1e0a45423db58ab2dfd3590571c/024d6/1440p_Settings_Cloud.png 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/9d95f1e0a45423db58ab2dfd3590571c/c0255/1440p_Settings_Cloud.png",
              "alt": "Web User Interface - 1440p Series - Cloud",
              "title": "Web User Interface - 1440p Series - Cloud",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <FTPTable mdxType="FTPTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Lesen Sie unsere Cloud Einführung hier: `}<Link to="/Bewegungserkennung/INSTAR_Cloud/" mdxType="Link"><EuiButton fill mdxType="EuiButton">{`INSTAR Cloud`}</EuiButton></Link></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      